module.exports = __webpack_public_path__ + "static/media/degenoba_riviero_cuesta.61fac5f4.jpg";